import React from 'react';

interface LoadingSkeletonProps {
  count?: number;
}

const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ count = 3 }) => {
  return (
    <div className="space-y-10">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="bg-white rounded-[2rem] border border-slate-200 p-8 animate-pulse">
          <div className="flex justify-between items-start mb-8">
            <div className="space-y-3 flex-1">
              <div className="h-8 bg-slate-100 rounded-xl w-1/3"></div>
              <div className="h-4 bg-slate-50 rounded-lg w-1/2"></div>
            </div>
            <div className="h-20 w-20 bg-slate-100 rounded-2xl"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
